"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldIgnoreThirdPartyScriptError = exports.isObscuraExtensionError = exports.isHoneyExtensionError = exports.isAntivirusInjectedError = exports.getFramePath = void 0;
exports.getCriticalPageInfo = getCriticalPageInfo;
const PAGE_MATCHERS = [
    // Exact matches from CRITICAL_PAGES
    { test: (pathname) => pathname === '/', name: 'homepage' },
    { test: (pathname) => pathname === '/art/', name: 'art' },
    { test: (pathname) => pathname === '/print/', name: 'print' },
    { test: (pathname) => pathname === '/all', name: 'browse-all' },
    { test: (pathname) => pathname === '/prints', name: 'browse-prints' },
    { test: (pathname) => pathname === '/paintings', name: 'browse-paintings' },
    { test: (pathname) => pathname === '/sculpture', name: 'browse-sculpture' },
    { test: (pathname) => pathname === '/photography', name: 'browse-photography' },
    { test: (pathname) => pathname === '/drawings', name: 'browse-drawings' },
    { test: (pathname) => pathname === '/collage', name: 'browse-collage' },
    { test: (pathname) => pathname === '/printmaking', name: 'browse-printmaking' },
    { test: (pathname) => pathname === '/mixed-media', name: 'browse-mixed-media' },
    { test: (pathname) => pathname === '/installation', name: 'browse-installation' },
    { test: (pathname) => pathname === '/digital', name: 'browse-digital' },
    { test: (pathname) => pathname === '/authentication', name: 'authentication' },
    { test: (pathname) => pathname === '/cart', name: 'cart' },
    { test: (pathname) => pathname === '/checkout', name: 'checkout' },
    { test: (pathname) => pathname === '/checkout/confirmation', name: 'checkout-confirmation' },
    { test: (pathname) => pathname === '/giftcard', name: 'giftcard' },
    { test: (pathname) => pathname === '/offer/', name: 'make-an-offer' },
    { test: (pathname) => pathname === '/accounts/offers', name: 'account-offers' },
    { test: (pathname) => pathname === '/studio/sales', name: 'studio-sales' },
    // Dynamic routes with REGEX patterns (from original implementation)
    {
        test: (pathname) => /^\/art\/.*\/view$/.test(pathname),
        name: 'product-detail-art',
    },
    {
        test: (pathname) => /^\/print\/.*\/view$/.test(pathname),
        name: 'product-detail-print',
    },
    {
        test: (pathname) => /^\/offer\/P\d+-U\d+-A\d+-T\d+/.test(pathname),
        name: (pathname) => pathname.includes('confirmation') ? 'mao-confirmation' : 'mao-checkout',
    },
    {
        test: (pathname) => /^\/accounts\/sale-confirmation\/\d+/.test(pathname),
        name: 'sale-confirmation',
    },
    { test: (pathname) => pathname === '/testpage', name: 'testpage' },
];
function getCriticalPageInfo(pathname) {
    if (!pathname)
        return null;
    const matcher = PAGE_MATCHERS.find((m) => m.test(pathname));
    if (!matcher)
        return null;
    const name = matcher.name;
    return typeof name === 'function' ? name(pathname) : name;
}
const getFramePath = (frame) => { var _a, _b; return `${(_a = frame.filename) !== null && _a !== void 0 ? _a : ''} ${(_b = frame.abs_path) !== null && _b !== void 0 ? _b : ''}`; };
exports.getFramePath = getFramePath;
const isAntivirusInjectedError = (exception) => {
    var _a, _b, _c;
    const isIllegalInvocation = exception.type === 'TypeError' && ((_a = exception.value) === null || _a === void 0 ? void 0 : _a.includes('Illegal invocation'));
    if (!isIllegalInvocation) {
        return false;
    }
    return ((_c = (_b = exception.stacktrace) === null || _b === void 0 ? void 0 : _b.frames) !== null && _c !== void 0 ? _c : []).some((frame) => {
        const path = (0, exports.getFramePath)(frame);
        return (path.includes('av.startpage.com') ||
            path.includes('/__av/') ||
            path.startsWith('app:///__av/'));
    });
};
exports.isAntivirusInjectedError = isAntivirusInjectedError;
const isHoneyExtensionError = (exception) => {
    var _a, _b;
    return ((_b = (_a = exception.stacktrace) === null || _a === void 0 ? void 0 : _a.frames) !== null && _b !== void 0 ? _b : []).some((frame) => {
        const path = (0, exports.getFramePath)(frame);
        return path.includes('Honey.safariextension') || path.includes('/Extension.appex/');
    });
};
exports.isHoneyExtensionError = isHoneyExtensionError;
const isObscuraExtensionError = (exception) => {
    var _a, _b;
    return ((_b = (_a = exception.stacktrace) === null || _a === void 0 ? void 0 : _a.frames) !== null && _b !== void 0 ? _b : []).some((frame) => {
        const path = (0, exports.getFramePath)(frame);
        return path.includes('obscura:bootstrap') || path.includes('ext:core/');
    });
};
exports.isObscuraExtensionError = isObscuraExtensionError;
const shouldIgnoreThirdPartyScriptError = (event) => {
    var _a, _b;
    return ((_b = (_a = event.exception) === null || _a === void 0 ? void 0 : _a.values) !== null && _b !== void 0 ? _b : []).some((exception) => (0, exports.isAntivirusInjectedError)(exception) ||
        (0, exports.isHoneyExtensionError)(exception) ||
        (0, exports.isObscuraExtensionError)(exception));
};
exports.shouldIgnoreThirdPartyScriptError = shouldIgnoreThirdPartyScriptError;
